import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { AdobeIntegrationLinkedService } from 'app/model/linkedservice/adobe-integration.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AdobeIntegrationLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                clientId: '*',
                techAccountId: '*',
                orgId: '*',
                exp: '*',
                journalEndpoint: '*',
                metaScopes: '*',
                tenantId: '*',
                clientSecret: 'secret',
                privateKeyContent: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class AdobeIntegrationLinkedServiceAdapter extends LinkedServiceAdapter<AdobeIntegrationLinkedService> {
    protected modelConstructor(): new () => AdobeIntegrationLinkedService {
        return AdobeIntegrationLinkedService;
    }

    protected model(): IModel {
        return AdobeIntegrationLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AdobeIntegrationLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AdobeIntegrationLinkedService;
        properties.type = Metamodel.modelFor(AdobeIntegrationLinkedService).name;

        properties.typeProperties = {
            clientId: linkedService.apiKey,
            techAccountId: linkedService.accountId,
            orgId: linkedService.orgId,
            exp: linkedService.exp,
            journalEndpoint: linkedService.journalEndpoint,
            metaScopes: linkedService.metaScopes.join(','),
            clientSecret: passwordOrAKVtoSecretBase(linkedService.clientSecret, this.context),
            privateKey: passwordOrAKVtoSecretBase(linkedService.privateKeyContent, this.context),
            tenantId: linkedService.tenantId
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AdobeIntegrationLinkedService): Promise<AdobeIntegrationLinkedService> {
        const properties = linkedServiceResource.properties as Model.AdobeIntegrationLinkedService;
        const typeProperties: Model.AdobeIntegrationLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.apiKey = typeProperties.clientId;
        linkedService.accountId = typeProperties.techAccountId;
        linkedService.orgId = typeProperties.orgId;
        linkedService.exp = typeProperties.exp;
        linkedService.journalEndpoint = typeProperties.journalEndpoint;
        linkedService.metaScopes = typeProperties.metaScopes.split(',');
        linkedService.clientSecret = secretBaseToPasswordOrAKV(typeProperties.clientSecret, true, this.context);
        linkedService.privateKeyContent = secretBaseToPasswordOrAKV(typeProperties.privateKey, true, this.context);
        linkedService.tenantId = typeProperties.tenantId;

        return linkedService;
    }
}
